<template>    
  <div id="headerNav" class="nav">
    <div class="nav-overlay" v-if="showOverlay"></div>
    <div class="container" style="position: relative;">
      <div class="nav-logo">        
          <a href="/"><div :class="curIndex === 1 ? 'logo-white background' : 'logo background'"></div></a>
      </div>
      <div class="header-nav">
        <ul>
          <li class="nav-item"><router-link to="/" :style="curIndex === 1 ? 'color: #343434;' : ''" @click="curIndex = 0">首页</router-link></li>
          <li class="nav-item"><router-link to="/about" :style="curIndex === 1 ? 'color: #343434;' : ''" @click="curIndex = 0">关于全澜</router-link></li>
           <li class="nav-item"><router-link to="/news" :style="curIndex === 1 ? 'color: #343434;' : ''" @click="curIndex = 0">新闻中心</router-link></li>
          <li class="nav-item" @mouseenter="handleSolutionEnter" @mouseleave="handleSolutionLeave">
            <router-link to="/solution" :style="curIndex === 1 ? 'color: #343434;' : ''" @click="curIndex = 0" @mouseenter="subItem = 0">解决方案</router-link>
            <!-- 一级菜单 -->
            <div class="nav-header" v-show="activeItem !== null">
              <div class="item link" :class="activeItem === 0 ? 'item-active' : ''"  @mouseenter="handleActiveItem(0)">科研</div>
              <div class="item link" :class="activeItem === 1 ? 'item-active' : ''"  @mouseenter="handleActiveItem(1)">睡眠调控</div>
            </div>
            <!-- 二级菜单 -->
            <div class="nav-solution" v-show="activeItem === 0">
              <div class="item link" :class="subItem === 1 ? 'sub-active' : ''"  @mouseenter="handleSubItem(1)">
                澜鲸高精度多通道系列
              </div>
              <div class="item link" :class="subItem === 2 ? 'sub-active' : ''"  @mouseenter="handleSubItem(2)">
                “澜猫”多模态无线系列
              </div>
              <div class="item link" :class="subItem === 3 ? 'sub-active' : ''"  @mouseenter="handleSubItem(3)">
                澜隼低功耗系列
              </div>
              <div class="item link" :class="subItem === 4 ? 'sub-active' : ''"  @mouseenter="handleSubItem(4)">
                数据分析与手术服务
              </div>
            </div>
            <div class="nav-solution" v-show="activeItem === 1">
              <div class="item link" @click="forwardTo('/sleepHome')">
                澜猫®睡眠小屋
              </div>
            </div>
            <!-- 三级菜单 -->
            <div class="sub-nav" v-show="activeItem === 0 && subItem === 1">
              <div class="item link" @click="forwardTo('/research01')">多功能闭环电刺激系统</div>
              <div class="item link" @click="forwardTo('/researchC64r')">RSC-64R 穿戴式脑电采集器</div>
            </div>
            <div class="sub-nav" v-show="activeItem === 0 && subItem === 2">
              <div class="item link" @click="forwardTo('/research02')">居家睡眠监测与调控</div>
              <div class="item link" @click="forwardTo('/research03')">小动物多模态无线电生理监测</div>
              <div class="item link" @click="forwardTo('/research32')">大动物用无线多通道电刺激-电生理监测</div>
              <div class="item link" @click="forwardTo('/arsLse')">光声电多模态刺激器 ARS-LSE</div>
            </div>
            <div class="sub-nav" v-show="activeItem === 0 && subItem === 3">
              <div class="item link" @click="forwardTo('/spike')">澜隼无线多通道spike采集系统</div>
            </div>
            <div class="sub-nav" v-show="activeItem === 0 && subItem === 4">
              <div class="item link" @click="forwardTo('/analysis')">数据分析服务</div>
              <div class="item link" @click="forwardTo('/operation')">手术与手术培训服务</div>
            </div>
          </li>
          <!-- <li class="nav-item"><router-link to="/product">产品中心</router-link></li> -->
          <li class="nav-item"><router-link to="/support" :style="curIndex === 1 ? 'color: #343434;' : ''" @click="curIndex = 0">服务支持</router-link></li>
          <li class="nav-item"><router-link to="/contact" :style="curIndex === 1 ? 'color: #343434;' : ''" @click="curIndex = 0">联系我们</router-link></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

  import { defineComponent } from 'vue';
  import { eventBus } from '@/utils/eventBus';

  export default defineComponent({
    data() {
      return {
        curIndex: 0,
        activeItem: null,
        subItem: null,
        showOverlay: false,
      };
    },
    watch: {
      // 监听 subItem 变化
      subItem(newVal) {
        if (newVal !== null) {
          this.showOverlay = true;
        }
      }
    },
    methods: {
      handleSolutionEnter() {
        // 清除关闭定时器
        if (this.menuTimer) {
          clearTimeout(this.menuTimer);
          this.menuTimer = null;
        }
        // 显示蒙版
        this.showOverlay = true;
        this.activeItem = 0;
      },
      handleSolutionLeave() {
        // 延迟关闭，给用户时间移动到子菜单
        this.menuTimer = setTimeout(() => {
          this.activeItem = null;
          this.subItem = null;
          this.showOverlay = false;
          this.menuTimer = null;
        }, 300);
      },
      handleActiveItem(index) {
        // 清除关闭定时器
        if (this.menuTimer) {
          clearTimeout(this.menuTimer);
          this.menuTimer = null;
        }
        this.activeItem = index;
        this.subItem = null;
        this.showOverlay = true;
      },
      handleSubItem(index) {
        this.subItem = index;
        this.showOverlay = true;
      },
      forwardTo(url) {
        this.curIndex = 0;
        window.location.href = url;
      }
    },
    mounted() {
      // 监听事件总线中的变化
      this.stopWatch = this.$watch(
          () => eventBus.curIndex.value,
          (newIndex) => {
            this.curIndex = newIndex;
          }
      );
    },
    beforeUnmount() {
      if (this.stopWatch) {
        this.stopWatch();
      }
    },
    computed: {
      logoStyle() {
        if (this.curIndex === 1) {
          return {
            backgroundImage: `url(${require('@/assets/images/ql_logo.png')})`
          };
        }
        return {};
      }
    }
  });

  function throttle(func, limit) {
    let inThrottle;
    return function() {
      const args = arguments;
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const context = this;
      if (!inThrottle) {
        func.apply(context, args);
        inThrottle = true;
        setTimeout(() => (inThrottle = false), limit);
      }
    };
  }

  const throttledScrollHandler = throttle(function() {
    var scrollY = window.pageYOffset || document.documentElement.scrollTop;
    var el = document.getElementById("headerNav");
    if (scrollY > 50) {
      el.classList.add("ennav");
    } else {
      el.classList.remove("ennav");
    }
  }, 10); // 节流时间设置为 100 毫秒

  window.addEventListener('scroll', throttledScrollHandler);
</script>
